module.exports = __webpack_public_path__ + "static/media/criterion.6eb94c6e.png";